import './App.css';
import React, { useState } from 'react';
import PlayAudio from './Component/PlayAudio'; 

function App() {
  const [musicNumber, setMusicNumber] = useState();
  return (
    <div className="">
      <PlayAudio props={{ musicNumber, setMusicNumber }} />
    </div>
  );
}

export default App;
